import React from 'react';
import cx from 'classnames';

import Text from '../Text';
import InlineLink from '../InlineLink';

import styles from './BreadcrumbsItem.module.scss';

export interface BreadcrumbsItemProps {
  /** The content for `Breadcrumbs.Item`. */
  children: React.ReactNode;
  /** Apply CSS class to `Breadcrumbs.Item`. */
  className?: Parameters<typeof cx>[0];
  /** The component that will wrap around `Breadcrumbs.Item`. In most cases, it would be `Link` from React Router or any other framework. */
  component?: React.ComponentType<any>;
  /** Specific the variant of `Breadcrumbs.Item`. */
  variant?: 'default' | 'current';
  /** A string that represents the `Link` location. */
  to?: string | undefined;
}

export const BreadcrumbsItem: React.FC<BreadcrumbsItemProps> = ({
  children,
  component,
  to,
  variant,
  className,
}) => {
  if (to === undefined || component === undefined) {
    return (
      <li className={cx(styles.breadcrumbItem)}>
        <Text as='span' size={14} className={className}>
          {children}
        </Text>
      </li>
    );
  }
  return (
    <li className={cx(styles.breadcrumbItem)}>
      <InlineLink
        component={component}
        to={to}
        className={cx(
          styles.breadcrumbLink,
          variant && styles[variant],
          className,
        )}
        textClassName={styles.linkText}
      >
        {children}
      </InlineLink>
    </li>
  );
};

export default BreadcrumbsItem;
export { styles };
